"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var shared_1 = require("../shared");
var shared_2 = require("@formily/shared");
exports.useFormQuery = function (resource, middlewares, context) {
    var ref = react_1.useRef();
    var _a = react_1.useState({
        loading: false,
        response: {},
        error: null
    }), state = _a[0], setState = _a[1];
    ref.current = state;
    return __assign({ loading: ref.current.loading, response: ref.current.response, error: ref.current.error }, react_1.useMemo(function () {
        var trigger;
        var promise;
        var resolve;
        var onSubmit = function () {
            promise = new Promise(function (_resolve) {
                resolve = _resolve;
            });
            return promise;
        };
        var effects = shared_1.createQueryEffects(resource, __spreadArrays([
            function (_a) {
                var actions = _a.actions;
                trigger = function (type) {
                    if (type === void 0) { type = 'onFormSubmitQuery'; }
                    actions.dispatch(shared_1.ON_FORM_QUERY, type);
                };
                return {
                    onFormWillQuery: function (payload, next) {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setState(__assign(__assign({}, ref.current), { loading: true }));
                                return [2, next(payload)];
                            });
                        });
                    },
                    onFormQueryFailed: function (error, next) {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setState(__assign(__assign({}, ref.current), { loading: false, error: error }));
                                return [2, next(error)];
                            });
                        });
                    }
                };
            }
        ], shared_2.toArr(middlewares), [
            function () { return ({
                onFormDidQuery: function (payload, next) {
                    return __awaiter(this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, next(payload)];
                                case 1:
                                    response = _a.sent();
                                    setState(__assign(__assign({}, ref.current), { loading: false, response: response }));
                                    if (resolve) {
                                        resolve();
                                    }
                                    return [2, response];
                            }
                        });
                    });
                }
            }); }
        ]), context);
        return {
            effects: effects,
            onSubmit: onSubmit,
            trigger: function (type) {
                if (trigger) {
                    trigger(type);
                }
            }
        };
    }, []));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useFormQuery.js
// module id = 5771
// module chunks = 0